// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1nJTk","dragIcon":"SortableItem_dragIcon__2oh9x","disabled":"SortableItem_disabled__1Nj6l"};